// Remove a imagem associada a um curso pelo ID do curso

import { Api } from "../axios-config";

const removePictureByCourseId = async (courseId: string): Promise<{ message: string } | Error> => {
  try {
    const urlRelativa = `/pictures/course/${courseId}`;
    const { data } = await Api.delete(urlRelativa);
    return data;
  } catch (error) {
    return new Error((error as { message: string }).message || "Erro ao remover imagem");
  }
};


// Permite upload usando FormData já pronto (para uso em modais genéricos)
const uploadPicture = async (formData: FormData): Promise<IUploadResponse | Error> => {
  try {
    const urlRelativa = "/pictures/upload";
    const { data } = await Api.post(urlRelativa, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    return new Error((error as { message: string }).message || "Erro ao fazer upload da imagem");
  }
};

export interface IUploadResponse {
  _id: string;
  name: string;
  size: number;
  key: string;
  url: string;
  date: string;
}

export interface IPicture {
  _id: string;
  name: string;
  size: number;
  key: string;
  url: string;
  date: string;
}

const uploadImage = async (image: File): Promise<IUploadResponse | Error> => {
  try {
    const urlRelativa = "/pictures/upload";
    const formData = new FormData();
    formData.append("image", image);

    const { data } = await Api.post(urlRelativa, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    //console.error(error);
    return new Error((error as { message: string }).message || "Erro ao fazer upload da imagem");
  }
};

const getPictureByID = async (id: string): Promise<IPicture | Error> => {
  try {
    const urlRelativa = `/pictures/${id}`;

    const { data } = await Api.get(urlRelativa);

    return data;
  } catch (error) {
    //console.error(error);
    return new Error((error as { message: string }).message || "Erro ao buscar imagem");
  }
}

export const picturesServices = { uploadImage, uploadPicture, getPictureByID, removePictureByCourseId };